import { type PostContentObjectDetail, createPostContentObjectDetail } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useContentObjectCache } from 'features/feed/queries/cache';
import { repostContentObject } from '../../services';

export const useRepostContentObjectMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<
    PostContentObjectDetail,
    { communityId: string; htmlContent?: string; objectId: string; textContent?: string }
  >({
    async mutationFn({ communityId, htmlContent, objectId, textContent }) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      const response = await repostContentObject({
        post: {
          html_content: htmlContent,
          post_in_communities: [{ id: communityId }],
          shared_content_object_id: objectId,
          text_content: textContent,
        },
      });

      /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */
      return createPostContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.create(data);
    },
  });
};
